import React from "react";
import { FaWhatsapp, FaPhoneAlt, FaInstagram } from "react-icons/fa";
import { RiRobot2Fill } from "react-icons/ri";
import "./css/ContactButtons.css";

const ContactButtons = () => {
  return (
    <div className="contact-buttons">
      <a
        href="/asistan"
        aria-label="AI Asistan ile sohbet et"
        className="contact-button ai-button"
      >
        <RiRobot2Fill />
        <span className="ai-badge">YENİ</span>
      </a>
      <a
        href="tel:+905055517747"
        aria-label="Telefon numarasını aramak için tıklayın"
        className="contact-button phone-button"
      >
        <FaPhoneAlt />
      </a>
      <a
        href="https://wa.me/+905055517747"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp üzerinden iletişime geç"
        className="contact-button whatsapp-button"
      >
        <FaWhatsapp />
      </a>
      <a
        href="https://www.instagram.com/cg.dilanaslan/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram sayfamızı ziyaret edin"
        className="contact-button insta-button"
      >
        <FaInstagram />
      </a>
    </div>
  );
};

export default ContactButtons;
